import { unwrap } from 'solid-js/store';
import { addItem } from 'Shared/forms/StoreRepeater';
import { initImage } from 'Shared/backend/widgets/CreationUtils';
import { traverseComponents } from 'Shared/backend/widgets/traverseComponents';


export async function copyComponentItem(sw: any, field: string, items: any[], index: number)
{
	const clone = structuredClone(unwrap(items[index]));
	traverseComponents(clone, (node: any) => {
		if (node.layout === 'image') {
			Object.assign(node, initImage());
			delete node.image;
		}
	});
	await addItem(sw, field, clone);
}
